import {
  UploadDocumentStateTypes,
  UploadDocumentActionTypes,
} from "./UploadDocument.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: UploadDocumentStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
  fetchReference: resetApiCallState(null),
};

const UploadDocumentReducer = (
  state: UploadDocumentStateTypes = INITIAL_STATE,
  action: any
): UploadDocumentStateTypes => {
  switch (action.type) {
    case UploadDocumentActionTypes.FETCH_ALL_UPLOAD_DOCUMENT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case UploadDocumentActionTypes.FETCH_ALL_UPLOAD_DOCUMENT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case UploadDocumentActionTypes.FETCH_ALL_UPLOAD_DOCUMENT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case UploadDocumentActionTypes.FETCH_ALL_UPLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case UploadDocumentActionTypes.FETCH_ONE_UPLOAD_DOCUMENT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case UploadDocumentActionTypes.FETCH_ONE_UPLOAD_DOCUMENT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case UploadDocumentActionTypes.FETCH_ONE_UPLOAD_DOCUMENT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case UploadDocumentActionTypes.FETCH_ONE_UPLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case UploadDocumentActionTypes.FETCH_UPLOAD_DOCUMENT_REFERENCE_NUMBER:
      return {
        ...state,
        fetchReference: {
          error: null,
          payload: null,
          isPending: true,
          isSuccessful: false,
        },
      };
    case UploadDocumentActionTypes.FETCH_UPLOAD_DOCUMENT_REFERENCE_NUMBER_RESET:
      return {
        ...state,
        fetchReference: resetApiCallState(null),
      };
    case UploadDocumentActionTypes.FETCH_UPLOAD_DOCUMENT_REFERENCE_NUMBER_FAILURE:
      return {
        ...state,
        fetchReference: {
          payload: null,
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case UploadDocumentActionTypes.FETCH_UPLOAD_DOCUMENT_REFERENCE_NUMBER_SUCCESS:
      return {
        ...state,
        fetchReference: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default UploadDocumentReducer;
